module.exports = __webpack_public_path__ + "static/media/HCMM897.0ebb9359.jpg";